import HeroSecondaryWrapper from './hero-secondary-wrapper'

export default HeroSecondaryWrapper
